import { request, downloadRequest } from '@/utils/request'

/* 乘客會員資料 */

// get
export const reqCustomerList = (params) =>
  request.get('customer/list', { params })



// WEBPACK FOOTER //
// ./src/api/customerInfo/index.js